
export type DraggableComponentData = {
	componentRegistrationId: string
}

export function isDraggableComponent(data: unknown): data is DraggableComponentData {
	const castData = data as DraggableComponentData
	return castData.componentRegistrationId !== undefined
}